import { Light } from "react-syntax-highlighter";
import atomOneDark from "react-syntax-highlighter/dist/cjs/styles/hljs/atom-one-dark";
import bash from "react-syntax-highlighter/dist/esm/languages/hljs/bash";
import js from "react-syntax-highlighter/dist/esm/languages/hljs/javascript";
import python from "react-syntax-highlighter/dist/esm/languages/hljs/python";
import { Language } from "./code-data";

Light.registerLanguage("javascript", js);
Light.registerLanguage("python", python);
Light.registerLanguage("bash", bash);

export function SyntaxHighlighter({ language, code }: { language: Language; code: string }) {
  return (
    <Light
      language={language === "node" ? "javascript" : language}
      style={atomOneDark}
      className="h-[340px] overflow-y-hidden rounded-lg p-4! text-sm sm:overflow-y-scroll"
      customStyle={{ background: "transparent" }}
    >
      {code}
    </Light>
  );
}
